import type { ReactNode, JSX } from 'react';
import Box from '@mui/material/Box';
import { Caption } from '../../../../typography';
import { useIntl } from '@doxyme/locale';
import { Button } from '../../buttons/button';
import { useTheme } from '../../../../theme';

type UpgradeProps = {
  text: ReactNode;
  onClick?: () => void;
};

export const TooltipUpgrade = ({
  text,
  onClick,
}: UpgradeProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const theme = useTheme('dark');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 3,
        maxWidth: 168,
        padding: 1,
      }}
    >
      <Caption color={theme.text.generic.secondary}>{text}</Caption>
      {onClick && (
        <Button type='upgrade' onClick={onClick} size='xsmall' width='100%'>
          {formatMessage({ id: 'upgrade' })}
        </Button>
      )}
    </Box>
  );
};
